export default __webpack_public_path__ + "static/media/ally_logo.f419f8d4.svg";